const getters={
	currentRole: state=>state.currentRole
}
export default getters